import React from "react";
import FeatureDetailLayout from "../components/FeatureDetailLayout";

export default function WorkoutTracking() {
  return (
    <FeatureDetailLayout
      seoTitle="Workout Tracking"
      seoPath="/workout-tracking"
      noindex
      eyebrow="Workout Tracking"
      title="Every rep, set and session"
      highlight="measured precisely"
      description="Log and analyze your training with precision. Jollof Fit Kingdom captures volume, intensity and progression automatically, turning your effort into insight and your consistency into results."
      benefits={[
        { icon: "Dumbbell", title: "Smart logging", desc: "Fast, frictionless logging for strength, cardio and mobility — designed to disappear into your workout." },
        { icon: "BarChart3", title: "Volume & intensity", desc: "Automatic tracking of tonnage, intensity and effort across every muscle group." },
        { icon: "TrendingUp", title: "Progression insights", desc: "See exactly where you're improving and where to push next with clear trend analysis." },
        { icon: "Repeat", title: "Program templates", desc: "Build and reuse structured programs, or let your coaching generate them for you." },
        { icon: "Timer", title: "Session guidance", desc: "Rest timers, tempo and load recommendations keep every session optimized." },
        { icon: "HeartPulse", title: "Recovery aware", desc: "Training loads are balanced against your recovery to prevent burnout and injury." },
      ]}
      howItWorks={[
        { title: "Log your session", desc: "Record workouts in seconds with an interface built for the gym floor." },
        { title: "See the analysis", desc: "Instant breakdowns of volume, intensity and progression appear automatically." },
        { title: "Optimize with coaching", desc: "Guidance adapts your next session for maximum, sustainable progress." },
      ]}
    />
  );
}
